import { CredentialLevel, EnrollmentStatus, UsCitizenshipStatus, UsState } from '../types/eligibility';

const citizenshipOptions: UsCitizenshipStatus[] = [
  { code: 'USCitizen', description: 'US Citizen' },
  { code: 'PermanentResident', description: 'Permanent resident' },
  { code: 'NonResidentAlien', description: 'Non-resident alien' },
  { code: 'ResidentAlien', description: 'Resident alien' },
  { code: 'Refugee', description: 'Refugee' },
];

const enrollmentOptions: EnrollmentStatus[] = [
  { id: 'FullTime', description: 'Full-time student' },
  { id: 'HalfTime', description: 'Half-time student' },
  { id: 'LessThanHalfTime', description: 'Less than half-time student' },
];

const credentialLevelOptions: CredentialLevel[] = [
  { code: '3', title: 'Bachelor\'s' },
  { code: '5', title: 'Master\'s' },
  { code: '6', title: 'Doctorate' },
];

const certificateCredentialLevel = { code: '1', title: 'Certificate' };
const associateCredentialLevel = { code: '2', title: 'Associate\'s' };

const sponsorshipCredentialLevelOptions = [
  certificateCredentialLevel,
  associateCredentialLevel,
  ...credentialLevelOptions,
];

const stateOptions: UsState[] = [
  { abbreviation: 'AL', description: 'Alabama' },
  { abbreviation: 'AK', description: 'Alaska' },
  { abbreviation: 'AZ', description: 'Arizona' },
  { abbreviation: 'AR', description: 'Arkansas' },
  { abbreviation: 'CA', description: 'California' },
  { abbreviation: 'CO', description: 'Colorado' },
  { abbreviation: 'CT', description: 'Connecticut' },
  { abbreviation: 'DE', description: 'Delaware' },
  { abbreviation: 'FL', description: 'Florida' },
  { abbreviation: 'GA', description: 'Georgia' },
  { abbreviation: 'HI', description: 'Hawaii' },
  { abbreviation: 'ID', description: 'Idaho' },
  { abbreviation: 'IL', description: 'Illinois' },
  { abbreviation: 'IN', description: 'Indiana' },
  { abbreviation: 'IA', description: 'Iowa' },
  { abbreviation: 'KS', description: 'Kansas' },
  { abbreviation: 'KY', description: 'Kentucky' },
  { abbreviation: 'LA', description: 'Louisiana' },
  { abbreviation: 'ME', description: 'Maine' },
  { abbreviation: 'MD', description: 'Maryland' },
  { abbreviation: 'MA', description: 'Massachusetts' },
  { abbreviation: 'MI', description: 'Michigan' },
  { abbreviation: 'MN', description: 'Minnesota' },
  { abbreviation: 'MS', description: 'Mississippi' },
  { abbreviation: 'MO', description: 'Missouri' },
  { abbreviation: 'MT', description: 'Montana' },
  { abbreviation: 'NE', description: 'Nebraska' },
  { abbreviation: 'NV', description: 'Nevada' },
  { abbreviation: 'NH', description: 'New Hampshire' },
  { abbreviation: 'NJ', description: 'New Jersey' },
  { abbreviation: 'NM', description: 'New Mexico' },
  { abbreviation: 'NY', description: 'New York' },
  { abbreviation: 'NC', description: 'North Carolina' },
  { abbreviation: 'ND', description: 'North Dakota' },
  { abbreviation: 'OH', description: 'Ohio' },
  { abbreviation: 'OK', description: 'Oklahoma' },
  { abbreviation: 'OR', description: 'Oregon' },
  { abbreviation: 'PA', description: 'Pennsylvania' },
  { abbreviation: 'RI', description: 'Rhode Island' },
  { abbreviation: 'SC', description: 'South Carolina' },
  { abbreviation: 'SD', description: 'South Dakota' },
  { abbreviation: 'TN', description: 'Tennessee' },
  { abbreviation: 'TX', description: 'Texas' },
  { abbreviation: 'UT', description: 'Utah' },
  { abbreviation: 'VT', description: 'Vermont' },
  { abbreviation: 'VA', description: 'Virginia' },
  { abbreviation: 'WA', description: 'Washington' },
  { abbreviation: 'WV', description: 'West Virginia' },
  { abbreviation: 'WI', description: 'Wisconsin' },
  { abbreviation: 'WY', description: 'Wyoming' },
];

export { associateCredentialLevel, certificateCredentialLevel, citizenshipOptions, credentialLevelOptions, enrollmentOptions, sponsorshipCredentialLevelOptions, stateOptions };
